// extracted by mini-css-extract-plugin
export var hidden = "_ol-1";
export var visible = "_ol-0";